import moment from "moment"
import { GetFormatForMoment } from 'Core/data/Helpers';


export const getLastConnection = (row, format, messages, locale) => {
    
    let lastConnected = ''
    if (row?.lastConnected === "0000-00-00 00:00:00"){
        return messages['no_data']
    }

    const userDateFormat = GetFormatForMoment(format)
    
    lastConnected = moment().diff(row?.lastConnected, 'days') === 0 ? moment(row?.lastConnected).lang(locale).fromNow() : moment(row?.lastConnected).format(userDateFormat)

    return lastConnected
}